// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const FlipHorizontalOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M19.8 19.56l-4.3-4.3 4.3-4.29v8.59zM4.2 10.97l4.3 4.3-4.3 4.29v-8.59z","fill":"currentColor","stroke":"currentColor"}},{"tag":"path","attrs":{"d":"M12 9.91v10.71","stroke-width":"1.5","stroke":"currentColor"}},{"tag":"path","attrs":{"d":"M15.1 6.77l-1.6 1.5 4.13.13.13-4.14-1.6 1.5A5.85 5.85 0 006.24 8.3l1.51.05a4.39 4.39 0 017.34-1.58z","fill":"currentColor"}}]},"name":"flip-horizontal","theme":"outlined"};

const FlipHorizontalOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={FlipHorizontalOutlinedSvg} />;
  FlipHorizontalOutlined.displayName = 'FlipHorizontalOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(FlipHorizontalOutlined);
